import { Injectable, EventEmitter } from '@angular/core';

import { Observable ,  Subject } from 'rxjs';

import { SidePanel } from '../models/side-panel.model';

@Injectable()
export class SidePanelService {

    public data: SidePanel;
    public sidePanel$ = new Subject<any>();

    private saving: EventEmitter<any> = new EventEmitter<any>();

    public saveInProgress$: Observable<any> = this.saving.asObservable();


  newSidePanel(data: SidePanel): void {
    this.data = data;
    this.sidePanel$.next({ data: data });
  }

    toggleSidePanel(visible: boolean): void {
        if (this.data) {
            this.data.visible = visible;
            this.sidePanel$.next({ data: this.data });
        }
  }

  update(): Observable<any> {
    return this.sidePanel$.asObservable();
  }

  updateSectionData(componentName: string, componentData: any): boolean {  
      let dataUpdated = false;
      if (this.data != null) {
          let section = this.data.sections.find(section => section.componentName === componentName);
          if (section) {
              section.componentData = componentData;
              this.data.visible = false;
              this.sidePanel$.next({ data: this.data });
              dataUpdated = true;
          };
      }       
      return dataUpdated;
    }


}